/**
 * @generated SignedSource<<17f2bbb219130e35b52f473ff554e65b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicSearchResultListItemTopic$data = {
  readonly entityId: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "topicSearchResultListItemTopic";
};
export type topicSearchResultListItemTopic$key = {
  readonly " $data"?: topicSearchResultListItemTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicSearchResultListItemTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicSearchResultListItemTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "f8617e9a7cbdbc75e06aadcdc9cefb4c";

export default node;
